import { createSlice } from '@reduxjs/toolkit';

type InitialMobileMenuType = {
  isOpen: boolean;
};

const initialState: InitialMobileMenuType = {
  isOpen: false,
};

const mobileMenuSlice = createSlice({
  name: 'mobile-menu',
  initialState,
  reducers: {
    setIsOpen: (state, { payload }) => {
      state.isOpen = payload;
    },
  },
});

export const { setIsOpen } = mobileMenuSlice.actions;

export default mobileMenuSlice.reducer;
